import React, { Component } from 'react';
import SimpleNavigation from './simple-navigation';
import LogoButton from '../general-components/logo-button';
import Cart from './cart';
import { withTranslation } from 'react-i18next';
import axios from 'axios';
import { connect } from 'react-redux';
import { orderLengthAction } from '../general-components/content-base/paragraphs/paragraph-calendar/calendar-actions';

const mapStateToProps = state => ({
  orderLength: state.calenderStore.orderLength,
});

class SimpleHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuOpen: false,
      token: '',
      cart: this.props.orderLength
    }
  }

  componentDidMount() {
    this.setState({token: window.personalToken}, () => {
      axios({
        method: 'get',
        url: '/cart?_format=json',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': this.state.token
        }
      })
        .then((response) => {
          // handle success
          this.setState({
            cart: response.data
          }, () => this.props.dispatch(orderLengthAction(this.state.cart)))
        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })
    });
  }

  toggleMenu = () => {
    this.setState((state) => ({
      menuOpen: !state.menuOpen
    }));
  }

  render() {
    return (
      <>
        <div className="site-header-wrapper">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-2 menu-language">
                <div id="toggle-fullscreen-menu" onClick={this.toggleMenu}>
                  <img src={"/themes/custom/module_box/src/images/" + (this.state.menuOpen ? "close.svg" : "Hamburger_Desktop.svg") } />
                </div>
                <div className={`language ${window.tranlationURL === "" ? "disabled": ""}`}>
                  {this.props.i18n.language === 'de' &&
                  <a href={window.tranlationURL}>
                    <img src="/themes/custom/module_box/src/images/Sprache-EN.svg" alt=""/>
                  </a>
                  }
                  {this.props.i18n.language === 'en' &&
                  <div className="de-icon">
                    <a href={window.tranlationURL}>
                      DE
                    </a>
                  </div>

                  }
                </div>
              </div>
              <div className="col-lg-8 col-md-8 col-sm-8 logo">
                <LogoButton />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2 search-cart">
                <div className="search">
                  <a href="/search">
                    <img src="/themes/custom/module_box/src/images/Lupe-on.svg" alt="search"/>
                  </a>
                </div>
                <Cart cart={this.props.orderLength} />
              </div>
            </div>
          </div>
        </div>
        <SimpleNavigation mainMenuQuery={this.props.content} menuOpen={this.state.menuOpen} />
      </>
    );
  }
}

export default connect(mapStateToProps)(withTranslation()(SimpleHeader));
